<template>
  <v-card>

    <v-toolbar dark dense :color="appColor_IconInfo">
      <v-toolbar-title class="text-uppercase font-weight-regular">
        Performance Data
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon>
        <v-icon @click="$emit('close')">
          cancel
        </v-icon>
      </v-btn>
    </v-toolbar>

    <v-container
      :style="{ maxHeight: '600px', backgroundColor: 'white' }"
      class="overflow-y-auto pa-0"
      >
      <v-card>
        <v-card-title class="body-1 font-weight-medium">
          Performance Data Adjustments
        </v-card-title>
        <v-card-subtitle>
          Weight is the most common measurement taken to gauge performance and genetic worth.   Weights are adjusted to standardize the age at which animals are being compared.  Older cows tend to give birth to heavier calves and milk more heavily.  Birth weight, weaning weight and scrotal circumference are affected by the age of the dam and are adjusted before any comparisons are made.
        </v-card-subtitle>

        <v-card-title class="py-0 text-uppercase font-weight-medium">
          Phenotypic Data
        </v-card-title>

        <v-card-title class="body-1 font-weight-medium">
          BW - Adjusted Birth Weight
        </v-card-title>
        <v-card-subtitle class="pb-0">
          The weight of a calf taken within 24 hours of birth is the best indicator of calving ease and is highly heritable trait.  Actual birth weights are adjusted for age of dam.
        </v-card-subtitle>

        <v-card-title class="body-1 font-weight-medium">
          BW ADG - Adjusted Birth To Weaning Average Daily Gain
        </v-card-title>
        <v-card-subtitle class="pb-0">
          Average daily from birth to weaning, adjusted for the age of dam.
        </v-card-subtitle>

        <v-card-title class="body-1 font-weight-medium">
          On Test ADG
        </v-card-title>
        <v-card-subtitle class="pb-0">
          This value shows the ability of the bull to grow in the feedlot on test.  All bulls are fed a medium energy ration.
        </v-card-subtitle>

        <v-card-title class="body-1 font-weight-medium">
          Off Test Weight
        </v-card-title>
        <v-card-subtitle class="pb-0">
          Actual weight off test.
        </v-card-subtitle>

        <v-card-title class="body-1 font-weight-medium">
          365 Day Weight
        </v-card-title>
        <v-card-subtitle class="pb-0">
          Yearling weight adjusted to a constant age.  365 day weight includes adjusted birth weight, 180 day preweaning gain and postweaning gain.
        </v-card-subtitle>

        <v-card-title class="body-1 font-weight-medium">
          SC - Scrotal Circumference
        </v-card-title>
        <v-card-subtitle class="pb-0">
          Back fat measurements are done by ultra-sound. Back fat is related to carcass fat thickness and fleshing ability.
        </v-card-subtitle>

        <v-card-title class="body-1 font-weight-medium">
          Back Fat
        </v-card-title>
        <v-card-subtitle class="pb-0">
          This measurement indicates bull fertility.  Scrotal circumference is moderately to highly heritable and is correlated to age of puberty in female sibs and progeny.  Scrotal circumference measurements are adjusted to 365 days and for age of dam.
        </v-card-subtitle>

        <v-card-title class="body-1 font-weight-medium">
          Age of Dam
        </v-card-title>
        <v-card-subtitle class="pb-0">
          Age of the bull’s dam.  Bulls from older dams may be more likely to pass on difficult to measure characteristics that contribute to cows with longer productive lives.  Bulls from younger cows may pass on some of these characteristics, but their dams have not ‘proven’ themselves yet.
        </v-card-subtitle>

        <v-card-title class="body-1 font-weight-medium">
          DW - Dam Weight
        </v-card-title>
        <v-card-subtitle class="pb-0">
          Average of adjusted dam weight taken once a year in the fall.  These weights are adjusted for age of dam.
        </v-card-subtitle>
      </v-card>
    </v-container>
  </v-card>
</template>

<script>
import { AppColor } from '@/config.js'

export default {
  name: 'PerformanceData',
  data: () => ({
    appColor_IconInfo: AppColor.IconInfo
  })
}
</script>

